/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
// Extends From
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
// Ember Imports
import { action, computed } from '@ember/object';
import { mapBy, filter } from '@ember/object/computed';
import { service } from '@ember/service';
// External Imports
import ConnectionStatus from '@linc-technologies/linced-common/enums/connection-status';
import WondeSisType from '@linc-technologies/linced-common/enums/wonde-sis-type';

export default class ConnectionsController extends Controller {
  @action
  setSearchQuery(value) {
    this.searchQuery = value;
  }

  // Services
  @service
  toaster;

  // variables
  @tracked selectedStatus = 0;

  @tracked searchQuery = '';
  connectionDialogueOpen = false;

  //attrs
  ConnectionStatus = ConnectionStatus;

  WondeSisType = WondeSisType;

  // computed properties
  @mapBy('model.connections', 'schoolId')
  connectionSchoolIds;

  @filter('model.schools.@each{id}', function (school) {
    return !this.connectionSchoolIds.includes(school.id);
  })
  unlinkedSchools;

  @computed('model.schools.[]', 'model.connections.@each{schoolId,data}')
  get wondeSchools() {
    const connectionMap = new Map(
      this.model.connections.map((connection) => [
        connection.schoolId,
        connection,
      ]),
    );

    return this.model.schools
      .map((school) => {
        const match = connectionMap.get(school.id);

        if (match) {
          return {
            connection: match,
            school: school,
          };
        }
      })
      .filter((item) => !!item);
  }

  @computed('wondeSchools.[]', 'selectedStatus', 'searchQuery')
  get displaySchools() {
    let filteredSchools = this.wondeSchools;

    if (this.selectedStatus !== ConnectionStatus.UNSPECIFIED) {
      filteredSchools = this.wondeSchools.filter((school) => {
        return school.connection.status === this.selectedStatus;
      });
    }

    if (this.searchQuery !== '') {
      let filter = this.searchQuery.toLowerCase();
      filteredSchools = filteredSchools.filter((obj) => {
        let school = obj.school;
        let connection = obj.connection;
        if (school.get('name').toLowerCase().indexOf(filter) !== -1) {
          // School name matches filter.
          return true;
        }
        if (school.jurisdictionalId.toLowerCase().indexOf(filter) !== -1) {
          // Jurisdictional ID matches filter.
          return true;
        }
        if (connection.wondeId.toLowerCase().indexOf(filter) !== -1) {
          // Wonde ID matches filter.
          return true;
        }
        if (connection.displayStatus.toLowerCase().indexOf(filter) !== -1) {
          // Status matches filter.
          return true;
        }
        if (school.id === filter) {
          // School ID (UUID) matches filter completely (partial matches are ignored to avoid weird results).
          return true;
        }

        // None of the things we check against matched.
        return false;
      });
    }

    return filteredSchools.map((school) => {
      return school;
    });
  }

  @action
  refresh() {
    this.model.update();
  }

  @action
  setSelectedStatus(status) {
    this.selectedStatus = status.value;
  }

  // updateSIS performs a save on update when the record's SIS is changed.
  @action
  updateSIS(hash, selectedSIS) {
    let { connection, school } = hash;

    connection.set('sis', selectedSIS.value);
    connection
      .save()
      .then(() => {
        this.toaster.success(
          `Successfully updated ${school.name}'s SIS to ${selectedSIS.label}`,
        );
      })
      .catch(() => {
        this.toaster.error(
          `Error attempting to update ${school.name}'s SIS, please try again`,
        );
      });
  }
}
